import { AreaGroup, Sitemap, SitemapItem } from '@msdk/definitions'

/**
 * Look for an item with a specific id inside all items of the given sitemap
 */
export function findIdInSitemap(id: string, sitemap: Sitemap) {
  return search(id, sitemap.areas)
}

function search(id: string, areas: SitemapItem[]): SitemapItem | undefined {
  let found: SitemapItem | undefined = undefined
  for (let i = 0; i < areas.length; i++) {
    const current = areas[i]
    if (current.id == id) {
      found = current
    } else if (current.type === 'AreaGroup') {
      const areaGroup = current as AreaGroup
      found = search(id, areaGroup.items)
    }

    if (found) break
  }
  return found
}
